import React, { useState } from "react";
import { Modal, Badge, Form, Button } from "react-bootstrap";
import "../Style/ViewPlannerModal.css";
import AssignConfirmationModal from "./AssignConfirmationModal";

const ViewPlannerModal = ({ show, close, item, handleAssignPlanner }) => {
    const [showAssignConfirm, setShowAssignConfirm] = useState(false);
    return (
        <>
            <AssignConfirmationModal
                show={showAssignConfirm}
                close={() => setShowAssignConfirm(false)}
                onConfirm={async () => {
                    await handleAssignPlanner(item);
                    setShowAssignConfirm(false);
                }}
            />
            <Modal show={show} onHide={close} size="xl" centered backdrop="static">
                <Modal.Header closeButton className="plannerHeader">
                    <div>
                        <h3>Planner Details</h3>
                    </div>
                </Modal.Header>

                <Modal.Body className="plannerBody">
                    <div className="plannerSummary">
                        <div>
                            <h4>{item?.plannerName}</h4>
                        </div>
                        <Badge
                            bg="primary"
                            className="plannerBadge"
                        >
                            Total Tasks : {item?.taskList?.length || 0}
                        </Badge>
                    </div>

                    {/* table */}
                    <div className="table-responsive">
                        <table className="table table-bordered planner-table">
                            <thead className="table-dark">
                                <tr>
                                    <th>Task Title</th>
                                    <th>Description</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Hours</th>
                                    <th>Minutes</th>
                                    <th>Assign To</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    item?.taskList?.map((task, index) => (
                                        <tr key={index}>
                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    value={task?.taskTitle || ""}
                                                    readOnly
                                                />
                                            </td>

                                            {/* description */}
                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    value={task?.taskDescription || ""}
                                                    readOnly
                                                />
                                            </td>

                                            {/* start date */}
                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    value={task?.startDate || ""}
                                                    readOnly
                                                />
                                            </td>

                                            {/* end date */}
                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    value={task?.endDate || ""}
                                                    readOnly
                                                />
                                            </td>

                                            {/* hours */}
                                            <td>
                                                <Form.Control
                                                    value={task?.estimatedHours || ""}
                                                    readOnly
                                                />
                                            </td>

                                            {/* minutes */}
                                            <td>
                                                <Form.Control
                                                    value={task?.estimatedMinutes || ""}
                                                    readOnly
                                                />
                                            </td>
                                            {/* assign to  */}
                                            <td>
                                                <Form.Control
                                                    value={task?.assignToName || ""}
                                                    readOnly
                                                />
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        className="activeBtn footer-btn"
                        onClick={() => setShowAssignConfirm(true)}
                    >
                        Assign Planner
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewPlannerModal;